// extracted by mini-css-extract-plugin
module.exports = {"button":"ActionForMultiSelect_button__1WIIl"};